"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _SessionModal = require("./SessionModal.style");
var _DesktopIcon = _interopRequireDefault(require("./icons/DesktopIcon"));
var _MobileIcon = _interopRequireDefault(require("./icons/MobileIcon"));
const SessionModal = _ref => {
  let {
    testId,
    onClose,
    bodyMessages,
    title,
    primaryButton,
    ModalComp,
    isDisplayedCloseButton,
    closeButtonText
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SessionModal.ModalContainer, null, /*#__PURE__*/_react.default.createElement(ModalComp, {
    testId: testId,
    ariaLabel: title,
    isOpen: true,
    variant: "Medium",
    version: "V2",
    onDismiss: onClose,
    allowOverflow: true,
    header: {
      visible: true,
      title
    },
    footer: {
      visible: true,
      FooterContent: () => /*#__PURE__*/_react.default.createElement(_SessionModal.Footer, null, isDisplayedCloseButton && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        testId: "modal-footer-cancel-btn",
        onClick: onClose,
        variant: "Tertiary"
      }, closeButtonText), primaryButton && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        testId: "modal-footer-primary-btn",
        onClick: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.onClick,
        variant: "AuthoringPrimary"
      }, primaryButton.text))
    }
  }, /*#__PURE__*/_react.default.createElement(_SessionModal.Wrapper, null, /*#__PURE__*/_react.default.createElement(_SessionModal.Container, null, /*#__PURE__*/_react.default.createElement(_SessionModal.MessagesWrapper, null, bodyMessages.map((message, index) => {
    const showIcon = index === 1 ? /*#__PURE__*/_react.default.createElement(_DesktopIcon.default, null) : index === 2 || index === 3 ? /*#__PURE__*/_react.default.createElement(_MobileIcon.default, null) : false;
    return /*#__PURE__*/_react.default.createElement(_SessionModal.IconTextWrapper, {
      key: index
    }, showIcon && /*#__PURE__*/_react.default.createElement(_SessionModal.IconWrapper, null, " ", showIcon, " "), /*#__PURE__*/_react.default.createElement(_uiKit.Text.Body, {
      "data-testid": "session-message",
      key: index
    }, message));
  }))))));
};
var _default = exports.default = SessionModal;